import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { certificacoesService } from '../../services';
import { Certificacao } from '../../types/aquisicao';

const columns: ResourceColumn<Certificacao>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
];

export const CertificacoesListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Certificações"
      description="Catálogo de certificações utilizadas pelos fornecedores."
      columns={columns}
      service={certificacoesService}
      createPath="/admin/aquisicao/certificacoes/novo"
      onEdit={(item) =>
        item.id &&
        navigate('/admin/aquisicao/certificacoes/editar', { state: { record: item } })
      }
      onDelete={(item) => (item.id ? certificacoesService.remove(item.id) : Promise.resolve())}
    />
  );
};
